
// 颜色枚举
export enum Colors {
    // 浅色
    Purple = 1,
    Blue,
    Green,
    Yellow,
    Red,
    Gray,
    White,
    // 深色
    DarkPurple,
    DarkBlue,
    DarkGreen,
    DarkYellow,
    DarkRed,
    Black,
    DarkGray,
    // 透明
    Transparent,
}

// 文本颜色映射
export const TextColorMap = {
    [Colors.Purple]: '#8995FA',
    [Colors.Blue]: '#4DA3FF',
    [Colors.Green]: '#4FD972',
    [Colors.Yellow]: '#FFC859',
    [Colors.Red]: '#FF9999',
    [Colors.Gray]: '#878D99',
    [Colors.White]: '#FFFFFF',
    // 深色
    [Colors.DarkPurple]: '#4F54D6',
    [Colors.DarkBlue]: '#0F6FD6',
    [Colors.DarkGreen]: '#0DAE2F',
    [Colors.DarkYellow]: '#FF930F',
    [Colors.DarkRed]: '#E61300',
    [Colors.Black]: '#1C1D1F',
    [Colors.DarkGray]: '#E1E6F0',
};

// 文本背景色映射
export const TextBgColorMap = {
    [Colors.Purple]: '#E1E4FF',
    [Colors.Blue]: '#D5E7FB',
    [Colors.Green]: '#C2F2CE',
    [Colors.Yellow]: '#FAEAC8',
    [Colors.Red]: '#FFE6E6',
    [Colors.Gray]: '#F2F4F7',
    // 深色
    [Colors.DarkPurple]: '#6977EC',
    [Colors.DarkBlue]: '#4498F2',
    [Colors.DarkGreen]: '#51C56F',
    [Colors.DarkYellow]: '#FFE14D',
    [Colors.DarkRed]: '#F86F59',
    [Colors.Black]: '#636568',
    [Colors.DarkGray]: '#878D99',
    // 透明
    [Colors.Transparent]: 'transparent',
};

// 布局块背景&边框枚举映射
export const BlockColorMap = {
    [Colors.Purple]: 'purple1',
    [Colors.Blue]: 'blue1',
    [Colors.Green]: 'green1',
    [Colors.Yellow]: 'yellow1',
    [Colors.Red]: 'red1',
    [Colors.Gray]: 'black1',
    // 深色
    [Colors.DarkPurple]: 'purple2',
    [Colors.DarkBlue]: 'blue2',
    [Colors.DarkGreen]: 'green2',
    [Colors.DarkYellow]: 'yellow2',
    [Colors.DarkRed]: 'red2',
    [Colors.Black]: 'black2',
    [Colors.DarkGray]: 'gray2',
    // 透明
    [Colors.Transparent]: 'transparent',
};

// 表格背景色映射
export const TableBgColorMap = {
    [Colors.Purple]: '#E1E4FF',
    [Colors.Blue]: '#D5E7FB',
    [Colors.Green]: '#C2F2CE',
    [Colors.Yellow]: '#FAEAC8',
    [Colors.Red]: '#FFE6E6',
    [Colors.Gray]: '#F2F4F7',
    // 深色
    [Colors.DarkPurple]: '#6977EC',
    [Colors.DarkBlue]: '#4498F2',
    [Colors.DarkGreen]: '#51C56F',
    [Colors.DarkYellow]: '#FFE14D',
    [Colors.DarkRed]: '#F86F59',
    [Colors.Black]: '#636568',
    [Colors.DarkGray]: '#878D99',
};
